import { render, staticRenderFns } from "./ConversationActions.vue?vue&type=template&id=bfcd917a&"
import script from "./ConversationActions.vue?vue&type=script&lang=js&"
export * from "./ConversationActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports